<template>
    <Modal :cancel="canCancel ? cancel : null"
           class="action-sheet-modal"
           cancel-on-backdrop-click>
        <SquareBtn v-for="btn in buttons"
                   :key="`btn-${btn.label}`"
                   :color="btn.color"
                   :disabled="!!btn.disabled"
                   :visually-disabled="!!btn.visuallyDisabled"
                   size="lg"
                   block
                   :title-key="btn.titleKey"
                   @click="btnClick(btn)">
            {{ l(btn.label) }}
        </SquareBtn>
    </Modal>
</template>

<script>
// A menu that pops up from the bottom of the screen on mobile, similar to an Action Sheet in iOS.
// See https://ionicframework.com/docs/api/action-sheet
// and https://www.hackingwithswift.com/quick-start/swiftui/how-to-show-an-action-sheet
// for examples.

import Modal from '@/vue/components/Modals/Modal';
import SquareBtn from '@/vue/components/SquareBtn';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'ActionSheetModal',

    components: { SquareBtn, Modal },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        buttons: {
            type: Array,
            required: true,
        },

        canCancel: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        btnClick(btn) {
            btn.click();
            this.resolve();
        },
    },
};
</script>

<style lang="less">
@import (reference) "../../../less/variables";

.action-sheet-modal {
    // Show this modal/menu at the bottom of the screen instead of the top.
    align-items: flex-end;

    .modl-header {
        display: none;
    }

    .modl-body {
        border-top-left-radius: @border-radius-base;
        border-top-right-radius: @border-radius-base;

        .btn {
            margin: 0;

            &:not(:first-child) {
                margin-top: @gutter-width-mobile;
            }
        }
    }
}
</style>
